import axios from "axios";

const origin = window.location.origin;
const [schemaSubdomain, domain, tld] = origin.split(".");

const apiSchemaSubdomain = `${schemaSubdomain}api`;

let backendUrl;

if (process.env.NODE_ENV == "production") {
  backendUrl = `${apiSchemaSubdomain}.${domain}.${tld}/v1`;
} else {
  backendUrl = "http://localhost:3001/v1";
}

const api = axios.create({
  baseURL: backendUrl,
});

// const http = Vue.observable({
//   hasError: false,
//   api,
//   raiseError() {
//     http.hasError = true;
//   },
// });

api.interceptors.response.use(
  (res) => {
    console.log("cao iz dobrog inter");
    return res;
  },
  (err) => {
    // http.raiseError();
    // api.errors = errors;
    return err;
    // return Promise.reject(err);
  }
);

export default api;
